import LateralMenu from '../../components/LateralMenu/LateralMenu'
import DragAndDrop from '../../components/DragAndDrop2/DragAndDrop'
import { Box, Container } from '@mui/material'
import ButtomComp from "../../components/Button/Button"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { pesquisaApi } from '../../services/apiPesquisa.servise'
import cloneDeep from 'lodash.clonedeep'
import { formState } from '../../store/reducers/data'
import { saveChange, setAllSegments, setImagens } from '../../store/reducers/dadosSegmentos'

export default function UploadImages(){
    const stateLength = useSelector(state => state.dadosSegmentos.length)
    const idHeader = useSelector(state => state.dadosHeader.idHeader)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const onClickHandler = async () => {
        const res = await pesquisaApi.getSections(idHeader);
        let arrayState = Array(res.data.length)
            .fill()
            .map(() => cloneDeep(formState));
        let data = await res.data;
        data.sort((a, b) => a.id_section - b.id_section);
        let imagens = []
        data.forEach((obj, i) => {
            for (let _data in data[i]) {
                if (
                    _data === "centre_0" ||
                    _data === "centre_20" ||
                    _data === "centre_40" ||
                    _data === "centre_60" ||
                    _data === "centre_80"
                ) {
                    imagens.push(data[i][_data])
                }
            }
        });
        dispatch(setImagens({ imagens: imagens }))

        arrayState.forEach((item, i) => {
            item.forEach((parametro, j) => {
                for (let datas in data[i]) {
                    if (datas === parametro.varName) {
                        parametro.selecionado.code = data[i][datas];
                        parametro.label.forEach((option) => {
                            if (option.code === data[i][datas]) {
                                parametro.selecionado.title = option.title;
                            }
                        });
                        arrayState[i][j].selecionado.code = data[i][datas];
                    }
                }
            });
        });
        dispatch(saveChange());
        dispatch(
            setAllSegments({ segmentos: arrayState, length: arrayState.length })
        );
        await pesquisaApi.uploadHeader({ hasImgs: true }, idHeader)
        navigate("/search", {
            state: {
                roadName: "tesate",
                snippet: "teste",
            },
        })
    }

    const handleFinish = async () => {
        // Só marca como tendo imagens se realmente houve upload (stateLength > 0)
        if (stateLength > 0) {
            await pesquisaApi.uploadHeader({ hasImgs: true }, idHeader);
        }
        navigate('/');
    };

    return(
        <Container sx={{ height: '100vh', width: "100%" }}>
            <LateralMenu />
            <Container sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginTop: "60px" }}>
                <DragAndDrop />
                <Box sx={{ width: "90%", display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
                    <ButtomComp 
                        disabled={stateLength <= 0} 
                        onClick={onClickHandler}
                    >
                        Iniciar codificação
                    </ButtomComp>
                    
                    <ButtomComp 
                        variant="outlined"
                        onClick={handleFinish}
                        // Opcional: desabilitar se não houver upload para evitar confusão
                        // disabled={stateLength <= 0}
                    >
                        Finalizar e voltar
                    </ButtomComp>
                </Box>
            </Container>
        </Container>
    )
}